import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class RemindPasswordRequest {
  @jsonMember(String)
  public email!: string;

  public constructor(email: string) {
    this.email = email;
  }
}
